import widgetService from 'live/services/widgets'
import TrackBar from './TrackBar'
import { reducer } from './reducer'
import i18n from 'live/services/i18n'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'

widgetService.register({
    type: 'TrackBar',
    get name() {
        return i18n('TrackBar')
    },
    get description() {
        return i18n('Bar chart with a fixed track')
    },
    config: {
        color: 'green'
    },
    // the wrapper is needed to enable the reducer mechanism and comply the API
    impl: reactWidgetWrapper<ChartState, ChartMessage, ChartConfigs>(TrackBar, reducer)
})
